import { gql } from '@lcs/shared/api';

export const saveFileMutation = gql`
   mutation SaveFile($file: FileInput!) {
      file: saveFile(file: $file) {
         fileId
         fileName
         fileToken
         metaTag
         accountId
      }
   }
`;
